import { pathOr } from 'ramda';

import { getProductPackReference } from '@/models/core/ProductPack';

/**
 * Get product stock quantity.
 *
 * @param productPack
 * @param stockDto
 * @return {number}
 */
export const getStockQuantity = (productPack, stockDto) => {
  const reference = getProductPackReference(productPack);

  return pathOr(0, [reference], stockDto);
};

/**
 * Check is product in stock.
 *
 * @param {ProductPack} productPack
 * @param {Object} stockDto
 * @return {boolean}
 */
export const isProductInStock = (productPack, stockDto) => {
  const stockNumber = getStockQuantity(productPack, stockDto);

  return stockNumber > 0;
};
